export default "__VITE_PUBLIC_ASSET__205b6d19__"